import CustomButton from "components/Atoms/CustomButton"
import { withFormController } from "components/Molecules/FormController"
import currencySymbol from "locale/currency"
import React from "react"
import clsx from "utils/clsx"
import useOrderIds from "./useOrderIds"

type OrderHeaderProps = {
  onChange: any
  showDiscount?: boolean
}

const OrderHeader = ({ onChange, showDiscount = false }: OrderHeaderProps) => {
  const orders = useOrderIds()
  const isConsolidated = orders?.length > 0
  return (
    <div className="grid grid-cols-12 gap-2">
      <div className="col-span-3 flex gap-3">
        <div>#</div>
        <div className="w-full">Sellable Item</div>
      </div>
      {isConsolidated && <div>Src. Rate ({currencySymbol}) </div>}
      <div>Rate ({currencySymbol})</div>
      <div className="flex flex-col items-center col-span-2">
        <div>Quantity</div>
        {isConsolidated && <div className="text-xs">(Consolidated)</div>}
      </div>
      <div>Total ({currencySymbol})</div>
      {!showDiscount ? (
        <></>
      ) : (
        <>
          <div>Discount Applied</div> <div>Total amt.</div>
        </>
      )}
      <div>{isConsolidated ? "Ground Stock" : "Stock"}</div>

      <div
        className={clsx(
          "col-span-2 flex ",
          showDiscount ? "justify-between" : ""
        )}
      >
        {showDiscount && <div>Coupon</div>}
        <CustomButton
          intent="danger"
          icon="trash"
          minimal
          onClick={e => onChange("orderItems", [])}
        />
      </div>
    </div>
  )
}

export default withFormController(OrderHeader)
